import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { PageToastMessagesService } from 'Angular/features/components/toast-messages/page-toast-messages-service';

import { IconModule } from '../../directives/icon/icon.module';

/**
 * Component that shows toast messages.
 * - One or more toast messages can be shown at a time.
 * - Defaults to stacking messages above each other in a vertical column.
 * - Defaults to showing messages in bottom left corner of page.
 */
@Component({
    selector: 'ycn-page-toast-messages',
    templateUrl: './toast-messages.template.html',
    standalone: true,
    imports: [CommonModule, IconModule],
})
export class PageToastMessagesComponent {
    // The class attribute of the container that holds toast messages.
    @Input() containerClass: string = 'toast toast-bottom-left flex-column';

    /**
     * The style attribute of the container that holds toast messages.
     * To customize where toast messages show, prefer setting the container style to `position: relative`, then wrapping
     * this component in a positioned element.
     *
     * Ex:
     * <div style='...'>
     *  <ycn-toast-messages [containerStyle]='position: relative; z-index: 2000'></ycn-toast-messages>
     * </div>
     */
    @Input() containerStyle: string = 'position: fixed; z-index: 2000';

    constructor(protected toastMessageService: PageToastMessagesService) {}
}
